import Immutable from "immutable";
const LOAD = "notes/LOAD";
const LOAD_SUCCESS = "notes/LOAD_SUCCESS";
const LOAD_FAIL = "notes/LOAD_FAIL";

const initialState = Immutable.fromJS({
  isLoad: false,
  loadErr: null,
  loading: false,
  notes: null,
});

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case LOAD:
      return state.set("isLoad", true).set("loadErr", null);

    case LOAD_SUCCESS:
      return state
        .set("isLoad", false)
        .set("loadErr", null)
        .set("notes", action.res);

    case LOAD_FAIL:
      return state
        .set("isLoad", false)
        .set("loadErr", action.error)
        .set("notes", null);

    default:
      return state;
  }
}

export const getNotes =
  (params = "") =>
  async (dispatch, getState, api) => {
    dispatch({ type: LOAD });
    if (params) {
      params = JSON.stringify(params);
    }
    try {
      let res = await api.get(`/notes/getNotes/${params}`);
      dispatch({ type: LOAD_SUCCESS, res: res });
      return res;
    } catch (err) {
      dispatch({ type: LOAD_FAIL, error: err.message });
    }
  };
